import React from 'react';

// Shown under an itinerary activity whose coordinates are low-precision (a coarse
// geocode). We surface this instead of dropping the place or silently mis-scheduling
// it — honest for free users; premium plans resolve the exact coord via Google.
// Self-contained (no theme dependency) so it drops into any itinerary render path.
export default function ApproximateLocationNote({ approximate }) {
  if (!approximate) return null;
  return (
    <p
      title="This place's coordinates are low-precision, so its exact spot and travel times may be off. We're improving location data — premium plans will use verified coordinates."
      style={{ color: '#C8891F', fontSize: 11, fontWeight: 600, margin: '4px 0', fontFamily: "'Montserrat',sans-serif" }}
    >
      📍 Approximate location — verify before you go
    </p>
  );
}
